import {
  LayoutDashboard, Award, Shield, Bell, User, Users, CalendarDays,
  Building2, School, Flag, UserCog, Settings2, FileBarChart, Download, ScrollText, BookUser,
  ShieldCheck, Cog, Archive, Users2, ListChecks, FolderArchive, BookOpen, Trash2, Eye, Mail, Drama, Clapperboard,
} from "lucide-react";

export const NAV = {
  team_member: [
    { to: "/member/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/member/merits", label: "Merit System", icon: Award, gate: "ff_merit" },
    { to: "/member/lettering", label: "Letter Points", icon: Shield, gate: "ff_lettering" },
    { to: "/member/thespian", label: "Thespian Points", icon: Drama, gate: "ff_thespian" },
    { to: "/member/show-notes", label: "Show Notes", icon: Clapperboard, gate: "ff_show_notes" },
    { to: "/member/document-depot", label: "Document Depot", icon: FolderArchive, gate: "ff_document_depot" },
    { to: "/member/schedule", label: "Daily Schedule", icon: CalendarDays, gate: "ff_schedule" },
    { to: "/member/choices", label: "Choices", icon: ListChecks, gate: "ff_choices" },
    { to: "/member/ledger", label: "Rally Books", icon: BookOpen, gate: "ff_rally_books" },
    { to: "/member/notifications", label: "Notifications", icon: Bell },
    { to: "/member/profile", label: "Profile", icon: User },
  ],
  coach: [
    { to: "/coach/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/coach/members", label: "Team Members", icon: UserCog },
    { to: "/coach/lettering", label: "Lettering Awards", icon: Shield, gate: "ff_lettering" },
    { to: "/coach/merits", label: "Merit System", icon: Award, gate: "ff_merit" },
    { to: "/coach/thespian", label: "Thespian Points", icon: Drama, gate: "ff_thespian" },
    { to: "/coach/show-notes", label: "Show Notes", icon: Clapperboard, gate: "ff_show_notes" },
    { to: "/coach/ledger", label: "Rally Books", icon: BookOpen, gate: "ff_rally_books" },
    { to: "/coach/choices", label: "Choices", icon: ListChecks, gate: "ff_choices" },
    { to: "/coach/document-depot", label: "Document Depot", icon: FolderArchive, gate: "ff_document_depot" },
    { to: "/coach/schedule", label: "Daily Schedule", icon: CalendarDays, gate: "ff_schedule" },
    { to: "/coach/notifications", label: "Notifications", icon: Bell },
    { to: "/coach/phonebook", label: "Phonebook", icon: BookUser, gate: "ff_phonebook" },
    { to: "/coach/profile", label: "Profile", icon: User },
  ],
  parent: [
    { to: "/parent/dashboard", label: "My Students", icon: Users },
    { to: "/parent/notifications", label: "Notifications", icon: Bell },
    { to: "/parent/profile", label: "Profile", icon: User },
  ],
  administrator: [
    { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/admin/organization", label: "Organization", icon: Building2 },
    { to: "/admin/accounts", label: "Users", icon: ShieldCheck },
    { to: "/admin/programs", label: "Programs", icon: Award },
    { to: "/admin/resources", label: "Resources", icon: BookUser },
    { to: "/admin/reports", label: "Reports", icon: FileBarChart },
    { to: "/admin/archive", label: "Archive", icon: Archive },
    { to: "/admin/notifications", label: "Notifications", icon: Bell },
    { to: "/admin/settings", label: "Settings", icon: Cog },
  ],
  district_administrator: [
    { to: "/staff/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/staff/users", label: "Users", icon: ShieldCheck },
    { to: "/staff/deletion-log", label: "Deletion Log", icon: Trash2 },
    { to: "/staff/profile", label: "Profile", icon: User },
  ],
  campus_administrator: [
    { to: "/staff/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/staff/users", label: "Users", icon: ShieldCheck },
    { to: "/staff/deletion-log", label: "Deletion Log", icon: Trash2 },
    { to: "/staff/profile", label: "Profile", icon: User },
  ],
};

export const ROLE_LABEL = {
  team_member: "Team Member",
  coach: "Coach",
  administrator: "System Administrator",
  district_administrator: "District Administrator",
  campus_administrator: "Campus Administrator",
  parent: "Parent",
};

export const ROLE_HOME = {
  team_member: "/member/dashboard",
  coach: "/coach/dashboard",
  administrator: "/admin/dashboard",
  district_administrator: "/staff/dashboard",
  campus_administrator: "/staff/dashboard",
  parent: "/parent/dashboard",
};
